import { useWasEnabled } from 'hooks/dialogs/cluster/_hooks/useWasEnabled';
import { useGetEdgeLocationDetailsQuery } from 'hooks/queries/omni';

export const useEdgeLocationOffboardingCompleted = ({
  clusterId,
  edgeLocationId,
  onSuccess,
  onError,
  enabled = true,
}: {
  clusterId: string;
  edgeLocationId: string;
  onSuccess: () => void;
  onError: () => void;
  enabled?: boolean;
}) => {
  const { edgeLocationDetails, error } = useGetEdgeLocationDetailsQuery({
    clusterId,
    edgeLocationId,
    refetchInterval: enabled ? 15_000 : false,
    enabled,
  });

  // Once offboarding is complete, the edge location will be deleted
  const offboardingCompleted = edgeLocationDetails === null;

  useWasEnabled({
    currentState: offboardingCompleted,
    onSuccess,
    onError,
    error,
    enabled,
  });
};
